import { FC, ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import SectionLabel from './SectionLabel';

interface DetailCardProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

const DetailCard: FC<DetailCardProps> = ({ title, action, children }) => (
  <Box
    sx={{
      bgcolor: 'background.paper',
      // Design-Rollout: wie karteSx (8px, Hairline, 24px innen).
      borderRadius: '8px',
      border: '1px solid',
      borderColor: 'divider',
      p: 6,
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
      <SectionLabel>{title}</SectionLabel>
      {action}
    </Stack>
    {children}
  </Box>
);

export default DetailCard;
